<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu :show_menu="true" :show_back_button="false" back_link="managerReports"/>
            <div class="content-wrapper" style="padding-left: 165px;">
                <div class="container-wrapper center">
									<div class="modal-custom" v-show="showOverlay">
										<div class="loader-img-center">
											<i class="fa fa-spinner fa-spin"></i> Please wait...
										</div>
									</div>


              <div class="my-3"></div>
              <div>
                <div style="width: 70%; float: left; text-align: left; ">
                  <h3 class="d-inline heading text-uppercase">Admin</h3>
                </div>
                <div style="width: 30%; float: right; text-align: right; " >
                  
                  <div style="clear: both;"></div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div class="border-bottom mt-1 mb-2"></div>

              <flash-message autoHide variant="success"></flash-message>


          <div class="row top-content" v-if="loading == true">
          <div class="col-1 p-0 pl-3" style="padding-top: 10px !important;">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
          <div class="col-9 text-right p-0 pl-3">
          </div>
          <div class="col-2 text-right p-0 pl-2 pr-2">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          </div>

          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-1" v-for="option in 5">
              <div class="col-3" style=" padding-left: 0px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-4" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-1" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>



                    <div class="">
                        
                    </div>
                    <div class="margin-bottom-10"></div>
                    <div v-if="loading == false">
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                <div class="col-6">
                                  <div class="pt-1">{{ usersCount }} Enterprise Admin(s)</div>
                                </div>
                                <div v-if="!isReadOnly" class="col-6 text-right mt-1">
                                  <a  class="add-new-admin mr-2" href="javascript:void(0)" @click="openNewEnterpriseAdmin">Add Enterprise Admin</a>
                                  <a v-if="isBranding == true" class="add-new-admin mr-2" href="javascript:void(0)" @click="openBrandingModal">Branding</a>
								  <a class="bg-[#EE4200] btn btn-md" href="javascript:void(0)" @click="openManageInviteModal"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-checks w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/pages/AdminPage.tsx:346:12" data-component-name="ListChecks"><path d="M13 5h8"></path><path d="M13 12h8"></path><path d="M13 19h8"></path><path d="m3 17 2 2 4-4"></path><path d="m3 7 2 2 4-4"></path></svg> Manage Invites</a>
                                </div>
                                
                            </div>
                            <div class="list_locations">
                                <div class="row enterprise-head-row">
                                    <div
                                        class="col-md-3" v-on:click="sortEAMethod('first_name')" style="cursor: pointer;">
                                        Name
                                        <i v-if="sortEAField == 'first_name' && sortEABy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortEAField == 'first_name' && sortEABy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>               
             
                                    </div>
                                    <div
                                        class="col-md-4" v-on:click="sortEAMethod('email')" style="cursor: pointer;">
                                        Email                          
                                        <i v-if="sortEAField == 'email' && sortEABy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortEAField == 'email' && sortEABy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>               


                                    </div>
                                    <div
                                        class="col-md-2">
                                        Phone Number                                       
                                    </div>
                                    <div
                                        class="col-md-2 text-center">
                                        Password
                                    </div>
                                    <div
                                        class="col-md-1 text-center" v-on:click="sortEAMethod('userStatus')" style="cursor: pointer;">
                                        Active
                                        <i v-if="sortEAField == 'userStatus' && sortEABy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortEAField == 'userStatus' && sortEABy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>               
                                    </div>
                                    
                                </div>
                                <div v-if="adminUsers.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(user, index) in adminUsers" :key="index">
                                        <div class="col-md-3"> {{ user.first_name }} {{ user.last_name }}
                                        <span v-if="user.is_primary_admin" class="badge badge-info text-uppercase admin-console-badge" >Primary</span>
                                        <span v-if="user.is_billing_admin && !user.is_primary_admin" class="badge badge-info text-uppercase admin-console-badge">Billing</span>

                                        </div>
                                        <div class="col-md-4"><i class="fa fa-envelope-o overview-icons"></i>&nbsp;{{ user.email }}</div>
                                        <div class="col-md-2">{{ (user.phone) ? user.phone : "Not Given" }}</div>
                                        <div class="col-md-2 text-center">
                                            <a class="offcanvas_link branding_text_color" @click="openResetLinkModal(user)"> Reset</a>
                                        </div>
                              

                              <div class="col-md-1  text-center inactive-link" style="" v-if="((user.status=='Active') && (user.is_primary_admin) && !isReadOnly)" @click="inactivatePrimaryUserConfirm(user)">
                                 Inactivate
                              </div>
                              <div class="col-md-1  text-center inactive-link" style="" v-else-if="((user.status=='Active') && !isReadOnly)" @click="inactivateUserConfirm(user)">
                               Inactivate
                              </div>
                              <div class="col-md-1  text-center active-link" v-else-if="!isReadOnly" @click="activateUserConfirm(user.uid, user.first_name, user.last_name)">Activate</div>
                              <div class="col-md-1  text-center active-link" v-else-if="user.status=='Active'" >Activate</div>
                              <div class="col-md-1  text-center inactive-link" v-else >Inactivate</div>


                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                    


          <div class="text-center pt-4" v-if="act_loading == true">
            <div class="row ml-1" v-for="option in 5">
              <div class="col-5" style=" padding-left: 0px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-1" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>

                     <div v-if="act_loading == false">
                        <b-card no-body class="manage_locations">
                            <div>                                
                                <h3 class="d-inline heading" style="margin-left: 0px;">Enterprise Account Activity</h3>
                                <a class="print_icons" href="javascript:void(0)" @click="downloadFunc()">
                                    <img class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" />
                                </a>
                            </div>
                            <div class="list_locations">
                               <div class="row enterprise-head-row">
                                    <div
                                        class="col-md-5">
                                        Event                                        
                                    </div>
                                    <div
                                        class="col-md-2">
                                        Admin                                        
                                    </div>
                                    <div
                                        class="col-md-2" v-on:click="sortMethod('updatedOn')" style="cursor: pointer;">
                                        Date  
                                        <i v-if="sortField == 'updatedOn' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'updatedOn' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>               

                                    </div>
                                    <div
                                        class="col-md-2">
                                        Time
                                    </div>
                                    <div
                                        class="col-md-1">
                                        &nbsp;
                                    </div>
                                    
                                </div>
                                <div  class="row_items">
                                    <div class="row_data_border row" v-for="(activity, aindex) in activityData" :key="aindex">
                                        <div class="col-md-5">{{activity.logMessage}}</div>
                                        <div class="col-md-2">{{activity.updatedBy}}</div>
                                        <div class="col-md-2">{{activity.updatedDate}}</div>
                                        <div class="col-md-2">
                                            {{activity.updatedTime}} (CST)
                                        </div>
                                        <div class="col-md-1">&nbsp; </div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                               
                            </div>
                                                                   
                        </b-card>
                    </div>                                                                        
                </div>
            </div>
        </div>

         <ResetLinkModal 
            :isModalVisible="isResetLinkModal" 
            ref="reset_modal_popup"
            @close="closeResetLinkModal"
        />

         <AddNewEnterpriseAdmin
            :isModalEAdminVisible="isModalEAdminVisible"             
            @close="closeEnterpriseAdminSidebar"
            ref="add_new_eadmin" 
        />

     <InactiveUser
        :isModalVisible="isInactiveUserModalVisible"
        :userName="userName"
        :userId="userId"
        :user="user"
        :inactivateUserDefaultAction="inactivateUserDefaultAction"
        ref="InactiveUserModal"
        @close="isInactiveUserModalVisible = false">
      </InactiveUser>

     <UpdatePrimaryEAModal
        :isUpdatePrimaryManagerModalVisible="isUpdatePrimaryManagerModalVisible"
        ref="update_primary_modal"
        :readOnly="isReadOnly"
        @close="closeUpdatePrimaryManagerModal"
        />

      <Branding
        :isModalVisible="isBrandingModalVisible"
        ref="BrandingModal"
        @close="isBrandingModalVisible = false">
      </Branding>
      <ManageInvite
        :isModalVisible="isManageInviteModalVisible"
        ref="ManageInviteModal"
        @close="isManageInviteModalVisible = false">
      </ManageInvite>

    </div>
</template>
<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import ResetLinkModal from './loation_reset_modal.vue';
import router from '../../router/index.js';
import { store } from '../../store/store';
import AddNewEnterpriseAdmin from './add_new_enterpriseadmin.vue';
import InactiveUser from '../manager/inactive_user_modal.vue';
import UpdatePrimaryEAModal from '@/components/enterpriseadmin/update_primary_enterprise_modal.vue';
import Branding from './branding_settings.vue';
import ManageInvite from '@/components/manager/manage_invite.vue';

export default {
    data() {
        return {
            loading: false,
            act_loading: false,
            isModalVisible: false,            
            adminUsers: [],
            activityData: [],
            isResetLinkModal: false,
            isModalEAdminVisible: false,         
            sortBy: 'DESC',
            sortField: 'updatedOn',
            sortEABy: '',
            sortEAField: '',
            usersCount: '',
            userId: '',
            userName: '',
            user: {},
            isInactiveUserModalVisible: false,
            inactivateUserDefaultAction: 'inactivate',
            isUpdatePrimaryManagerModalVisible: false,
            apiUrl: '',
            isBrandingModalVisible: false,
            type: '',
            isBrandingFlag: false,
						showOverlay: false,
						isManageInviteModalVisible: false,
        }
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      },
      isBranding() {
        if ((this.isBrandingFlag == true)) {
          return true;
        } else {
          return false;
        }
      },
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        ResetLinkModal,
        AddNewEnterpriseAdmin,
        InactiveUser,
        UpdatePrimaryEAModal,
        Branding,
				ManageInvite,
    },    
    methods: {        
			openManageInviteModal() {
     		this.isManageInviteModalVisible = true;
     		this.$refs.ManageInviteModal.loadInitialData();
    	},
        openBrandingModal() {
          this.isBrandingModalVisible = true;
          this.$refs.BrandingModal.loadInitialData();
        },
        downloadFunc: function() {
						this.showOverlay = true;
            const params = {  };
            if (this.sortField) {
                params.sortfield = this.sortField;
            }
            if (this.sortBy) {
                params.sortby = this.sortBy;
            }
            axios('/enterprise_account_activity_pdf',
            {
                params: params,
            })
            .then(response =>  {

              this.pdf_file_name = response.data.pdf_file_name;
              this.showOverlay = false;
              var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
   
              //Create XMLHTTP Request.
              var req = new XMLHttpRequest();
              req.open("GET", url, true);
              req.responseType = "blob";
              req.onload = function () {
                  //Convert the Byte Data to BLOB object.
                  var blob = new Blob([req.response], { type: "application/octetstream" });
   
                  //Check the Browser type and download the File.
                  var isIE = false || !!document.documentMode;
                  if (isIE) {
                      window.navigator.msSaveBlob(blob, fileName);
                  } else {
                      var url = window.URL || window.webkitURL;
                      var link = url.createObjectURL(blob);
                      var a = document.createElement("a");
                      a.setAttribute("download", "account_activity_lists.pdf");
                      a.setAttribute("href", link);
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                  }
              };
              req.send();
              return false;


            })
            .catch(function(error) {
                console.log(error);
            });


        },

        inactivateUser: function(item) {
            this.userId = item.uid;
            this.userName = item.first_name + ' ' + item.last_name;
            this.user = item;
            this.isInactiveUserModalVisible = true;
            this.inactivateUserDefaultAction = 'inactivate';
        },
        activateUser: function(id, name) {
            this.userId = id;
            this.userName = name;
            this.isInactiveUserModalVisible = true;
            this.inactivateUserDefaultAction = 'activate';
        },
        inactivateUserConfirm(item) {
           this.inactivateUser(item);
        },
        inactivatePrimaryUserConfirm(item) {
          this.isUpdatePrimaryManagerModalVisible = true;
          this.$refs.update_primary_modal.setUserInfo(item);
          this.$refs.update_primary_modal.getAllAdmins(this.$store.state.user_accountid);
        },  
        closeUpdatePrimaryManagerModal() {
          this.isUpdatePrimaryManagerModalVisible = false;
        },
        activateUserConfirm(id, first_name, last_name) {
           this.name = first_name + ' ' + last_name;           
           this.activateUser(id, this.name);
        },
        openResetLinkModal(user) {
            this.isResetLinkModal = true;
            this.$refs.reset_modal_popup.setUserInfo(user);
        },
        closeResetLinkModal() {
            this.isResetLinkModal = false;
            this.$refs.reset_modal_popup.setUserInfo({});
        },
        sortMethod(field) {
            this.sortField = field;
            if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
            }
            else {
                this.sortBy = 'ASC';
            }
            this.getEnterpriseAccountActivity();
        },
        sortEAMethod(field) {
          this.loading = true;
          this.sortEAField = field;
          if(this.sortEABy == 'ASC') {
              this.sortEABy = 'DESC';
          }
          else {
              this.sortEABy = 'ASC';
          }
          const params = {  };
          if (this.sortField) {
              params.sortfield = this.sortEAField;
          }
          if (this.sortBy) {
              params.sortby = this.sortEABy;
          }
          axios.get('/enterprise_info_admin_list', {
               params: params
          })
          .then(resp => {
            this.loading = false;
            this.adminUsers = resp.data;
            this.usersCount = this.adminUsers.length;
          })
          .catch(() => {
          });
            
        },
        getEnterpriseAccountActivity() {
           this.activityData = [];
           const params = {  };
            if (this.sortField) {
                params.sortfield = this.sortField;
            }
            if (this.sortBy) {
                params.sortby = this.sortBy;
            }
            axios.get('/enterprise_account_activity', {
                 params: params
              })
            .then(resp => {
              this.act_loading = false;
                this.activityData = resp.data;                          
            })
            .catch(() => {
            });
        },
        goToPrint(){             
            router.push('/print-enterprise-accavtivity')
        },
        openNewEnterpriseAdmin() {
            this.isModalEAdminVisible = true;                       
        },
        closeEnterpriseAdminSidebar() {
            this.isModalEAdminVisible = false;
        }
    },
    created() {
        var switchRoles = store.state.switch_admin_roles;
        if(switchRoles) {
          var roles = switchRoles;
        }
        else {
          var roles = store.state.roles;
        }
        this.apiUrl = process.env.API_ENDPOINT;
        this.loading = true;
        this.act_loading = true;
        if((roles.indexOf('ROLE_PRIMARY_ADMIN') === -1)) {
          router.push('/enterprise-admin-dashboard');
        }
        store.dispatch('clear_search_enterprise_locations');
        axios('/enterprise_info_admin_list',
        {
            method: 'GET',
        })
        .then(resp => {
            this.loading = false;
            this.adminUsers = resp.data.admin_lists;
            this.isBrandingFlag = resp.data.isBrandingFlag;
            this.usersCount = this.adminUsers.length;
            this.getEnterpriseAccountActivity();           
        })
        .catch(() => {
        });

    },
}
</script>
<style scoped>
.manage_locations { padding: 0rem 0rem 0rem 0rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.enterprise-head-row { font-weight: bold;   border-bottom: 4px solid #D1D5D5; color: #002f42; padding-bottom: 5px; }
.row_items { margin-right: -15px; margin-left: -15px }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid #D1D5D5; }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor: pointer;
}
.offcanvas_link { text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.loading_show { height: auto; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.heading { padding-left: 0px; }
.add-new-admin { padding: 5px 25px; text-decoration: none; color: #FFF; font-weight: 900; border-radius: 15px; }
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.inactive-link {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 0px;
  text-align: right;
  cursor: pointer;
}

.active-link {
  color: #28a745!important;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 0px;
  text-align: right;
  cursor: pointer;
}
.bg-\[\#EE4200\] {
    background-color: #EE4200;
    color: #FFF;
    border-radius: calc(0.625rem - 2px);
    border-color: #008FC7;
    border-width: 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_info.vue